<template>
    <div class="journey-planner__shortlist-wrapper">
        <div class="journey-planner__title">
            <h4>My Shortlist</h4>
            <div class="journey-planner__actions">
                <button
                    @click="handleEmpty"
                    class="journey-planner__action"
                    v-if="shortlist.data"
                >
                    <Trash></Trash>Empty shortlist
                </button>
            </div>
        </div>
        <draggable
            :list="shortlist.data"
            item-key="title"
            ghost-class="shortlist-item--ghost"
            @change="handleChange"
            group="listings"
            class="shortlist-item-wrapper"
        >
            <template #item="{ element }">
                <ShortlistItem
                    :image="element.image"
                    :title="element.title"
                    :summary="element.summary"
                    :link="element.link"
                    @remove="handleRemove(element.id)"
                >
                </ShortlistItem>
            </template>
        </draggable>
    </div>
</template>
<script>
import { useShortlistStore } from '@/vue/stores/shortlist.js'
import draggable from "vuedraggable";
import ShortlistItem from "@/vue/components/ShortlistItem";
import Trash from "@/vue/icons/Trash";

export default {
    components: {
        draggable,
        ShortlistItem,
        Trash
    },
    data() {
        return {
            shortlist: useShortlistStore(),
        };
    },
    created() {
        this.shortlist.getData()
    },
    methods: {
        handleRemove: function (id) {
            this.shortlist.remove(id)
        },
        handleChange: function () {
            this.shortlist.replaceData(this.shortlist.data)
        },
        handleEmpty: function () {
            this.shortlist.data = []
            this.handleChange()
        },
    },
};
</script>
